import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RegistrationPageComponent } from './registration-page.component';
import { RouterModule } from '@angular/router';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@NgModule({
  declarations: [RegistrationPageComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, NgxIntlTelInputModule],
  exports: [RegistrationPageComponent],
})
export class RegistrationPageModule {}
